import React, { Component } from 'react';
import Select from 'react-select';
import {HandleSubmit} from '../../func/HandleSubmit';
class AddUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Submit: '',
            RequestCode: 0,
            Products: 'none',
            SendParameters: {
                detail: {
                    user_name: "",
                    name: "",
                    password: "",
                    group_code: "",
                }
            },
            Validation: {},
            Loading: false,
            Header: {}
        };
        this.SetParameterValue = this.SetParameterValue.bind(this);
        this.GetGroup = this.GetGroup.bind(this);
        this.HandleSubmit = this.HandleSubmit.bind(this);
        this.CheckValidation = this.CheckValidation.bind(this);
        this.InitList = this.props.initlist.bind(this);
    }
    CheckValidation() {
        let ValidPass = true;
        let counter = 0;
        var ErrorMsg_Is_Blank = "IS BLANK";
        //Object.values(this.state.SendParameters.list(i => console.log(i)));
        Object.keys(this.state.SendParameters).forEach(element => {
            if (this.state.SendParameters[element] == "") {
                this.state.Validation = { ...this.state.Validation, [element]: ErrorMsg_Is_Blank };
            }
            else {
                this.state.Validation = { ...this.state.Validation, [element]: "" };
            }
        });
        if (ErrorMsg_Is_Blank !== "") {
            ValidPass = false;
        }
        this.setState(
            {
                Validation: this.state.Validation
            }
        );
        return ValidPass;
        //console.log(this.state.Validation);
    }
    async HandleSubmit() {
        this.setState({
            Loading: true,
            SendParameters: this.state.SendParameters
        });
        //////////////////////////////
        var response_info = await HandleSubmit('user/add', this.state.SendParameters);
        //alert(response_info.status.request_code);
        if (response_info.status.trim() === "OK") {
            alert("ثبت گردید");
            this.InitList();
        }
        else {
            alert("مشکل در ثبت");
        }
        this.setState({
            Loading: false,
        });
    }
    SetParameterValue(name, value) {
        this.state.SendParameters.detail = { ...this.state.SendParameters.detail, [name]: value };
        this.setState({
            SendParameters: this.state.SendParameters,
        });
        console.log(this.state.SendParameters);
        // this.CheckValidation();
    }
    async GetGroup() {
        //alert(this.state.SendParameters.group_code);
        var response_info = await HandleSubmit('group/getlist', '');
        this.setState({
            GroupName: response_info,
        });
        //console.log("gropu: ",this.state.GroupName);
    }

    async componentDidMount() {
        await this.GetGroup();

    }
    render() {
        //console.log(this.state.SendParameters.detail);
        if (this.state.Loading) { return "Loading..." }

        return (
            ShowForm(this.state.GroupName,
                this.state.SendParameters,
                this.state.Validation,
                this.SetParameterValue,
                this.HandleSubmit)
        );

    }
}
export default (AddUser);
const ShowForm = (items, defaultValue, Validation, funcSetParameterValue, funcHandleSubmit) => (
    <React.Fragment>
        <table className="table-responsive table-bordered table-striped" >
            <tbody>
                <tr>
                    <td>نام</td>
                    <td>
                        <input type="text"
                            className="form-control"
                            onChange={(e) => funcSetParameterValue('name', e.target.value)}
                            
                        />
                        <span>{Validation['name']}</span>
                    </td>
                </tr>
                <tr>
                    <td>نام کاربری</td>
                    <td>
                        <input type="text"
                            className="form-control"
                            onChange={(e) => funcSetParameterValue("user_name", e.target.value)}
                        />
                        <span>{Validation['user_name']}</span>
                    </td>
                </tr>
                <tr>
                    <td>رمز عبور </td>
                    <td>
                        <input type="text"
                            className="form-control"
                            type="password"
                            onChange={(e) => funcSetParameterValue("password", e.target.value)}
                        />
                        <span>{Validation['password']}</span>
                    </td>
                </tr>
                <tr>
                    <td>گروه</td>
                    <td><Select
                        defaultValue={{ label: (defaultValue.name), value: defaultValue.name }}
                        onChange={(value) => (funcSetParameterValue("group_code", value.value))}
                        options={items}
                    />
                        <span>{Validation['group_code']}</span>
                    </td>
                </tr>
                <tr>
                    <td style={{ "textAlign": "right" }}>
                        <button className="btn btn-success" onClick={() => funcHandleSubmit()}>اضافه شود</button>
                    </td>
                </tr>
            </tbody></table>
    </React.Fragment>
);




// WEBPACK FOOTER //
// ./src/pages/User/AddUser.js